import { CompanyInfoBadge } from '@aibees/elephant/components/company-info-badge';
import { PreviousEmploymentBadge } from '@aibees/elephant/components/previous-employment-badge';
import { Chip, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ContactOverviewItemProps as Props } from './types';

export const ContactOverviewItem = memo(
  ({
    className,
    icon,
    label,
    value,
    content,
    badgeLength,
    condition,
    type,
    onClick,
  }: Props) => {
    if (!value) return null;

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      if (onClick) {
        onClick(event);
      }
    };

    const BadgeComponent =
      type === 'company' ? CompanyInfoBadge : PreviousEmploymentBadge;

    return (
      <Styled.Wrapper
        className={classnames('ContactOverviewItem', className)}
        sx={SX.root}
      >
        <Stack sx={SX.row}>
          <Stack direction="row" alignItems="center" gap={1}>
            <BadgeComponent tooltipPlacement="left">
              <Icon name={icon} size={20} color="grey.500" />
            </BadgeComponent>
            <Typography variant="body3" color="grey.700" fontWeight={400}>
              {label}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={0.5}>
            {content}

            {condition && (
              <Chip
                label={`+${badgeLength}`}
                size="small"
                color="primary"
                variant="filled"
                shape="rounded"
                onClick={handleClick}
                sx={{ cursor: 'pointer' }}
              />
            )}
          </Stack>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

ContactOverviewItem.displayName = 'ContactOverviewItem';
